<div class="ds-grid ds-grid--2">
	<!-- ═══════════════════ SINGLE DATE PICKERS ═══════════════════ -->

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Single — Basic</h3>
			<p class="ds-example__header-subtitle">Default single date</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				[label]="'Event Date'"
				[fullWidth]="true"
				[placeholder]="'Select a date'"
				[name]="'single-basic'"
				(selectionChange)="singleBasic = $event">
			</eif-custom-date-picker>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">{{ singleBasic ?? '—' }}</div>
			</div>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Single — Flat Date</h3>
			<p class="ds-example__header-subtitle">emitFlatDate: true</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				[label]="'Event Date'"
				[fullWidth]="true"
				[placeholder]="'Select a date'"
				[name]="'single-flat'"
				[emitFlatDate]="true"
				(selectionChange)="singleFlatDate = $event">
			</eif-custom-date-picker>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">{{ singleFlatDate ?? '—' }}</div>
			</div>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Single — Format</h3>
			<p class="ds-example__header-subtitle">format: 'YYYY-MM-DD'</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				[label]="'Event Date'"
				[fullWidth]="true"
				[placeholder]="'Select a date'"
				[name]="'single-format'"
				[format]="'YYYY-MM-DD'"
				(selectionChange)="singleFormat = $event">
			</eif-custom-date-picker>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">{{ singleFormat ?? '—' }}</div>
			</div>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Single — Emit Format</h3>
			<p class="ds-example__header-subtitle">emitFormat: 'YYYY-MM-DD'</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				[label]="'Event Date'"
				[fullWidth]="true"
				[placeholder]="'Select a date'"
				[name]="'single-emit-format'"
				[emitFormat]="'YYYY-MM-DD'"
				(selectionChange)="singleEmitFormat = $event">
			</eif-custom-date-picker>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">{{ singleEmitFormat ?? '—' }}</div>
			</div>
		</div>
	</div>

	<!-- ═══════════════════ RANGE DATE PICKERS ═══════════════════ -->

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Range — Basic</h3>
			<p class="ds-example__header-subtitle">Default range date selection</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				[label]="'Date Range'"
				[fullWidth]="true"
				[placeholder]="'Select date range'"
				[name]="'range-basic'"
				[isRange]="true"
				[calendars]="2"
				(selectionChange)="rangeBasic = $event">
			</eif-custom-date-picker>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">{{ rangeBasic?.[0] ?? '—' }} — {{ rangeBasic?.[1] ?? '—' }}</div>
			</div>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Range — Flat Date</h3>
			<p class="ds-example__header-subtitle">emitFlatDate: true</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				[label]="'Date Range'"
				[fullWidth]="true"
				[placeholder]="'Select date range'"
				[name]="'range-flat'"
				[isRange]="true"
				[calendars]="2"
				[emitFlatDate]="true"
				(selectionChange)="rangeFlatDate = $event">
			</eif-custom-date-picker>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">{{ rangeFlatDate?.[0] ?? '—' }} — {{ rangeFlatDate?.[1] ?? '—' }}</div>
			</div>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Range — Format</h3>
			<p class="ds-example__header-subtitle">format: 'YYYY-MM-DD'</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				[label]="'Date Range'"
				[fullWidth]="true"
				[placeholder]="'Select date range'"
				[name]="'range-format'"
				[isRange]="true"
				[calendars]="2"
				[format]="'YYYY-MM-DD'"
				(selectionChange)="rangeFormat = $event">
			</eif-custom-date-picker>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">{{ rangeFormat?.[0] ?? '—' }} — {{ rangeFormat?.[1] ?? '—' }}</div>
			</div>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Range — Emit Format</h3>
			<p class="ds-example__header-subtitle">emitFormat: 'YYYY-MM-DD'</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				[label]="'Date Range'"
				[fullWidth]="true"
				[placeholder]="'Select date range'"
				[name]="'range-emit-format'"
				[isRange]="true"
				[calendars]="2"
				[emitFormat]="'YYYY-MM-DD'"
				(selectionChange)="rangeEmitFormat = $event">
			</eif-custom-date-picker>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">{{ rangeEmitFormat?.[0] ?? '—' }} — {{ rangeEmitFormat?.[1] ?? '—' }}</div>
			</div>
		</div>
	</div>

	<!-- ═══════════════════ SINGLE DATE + TIME PICKERS ═══════════════════ -->

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Single + Time — Basic</h3>
			<p class="ds-example__header-subtitle">showTime: true</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				[label]="'Meeting DateTime'"
				[fullWidth]="true"
				[placeholder]="'Select date and time'"
				[name]="'single-time-basic'"
				[showTime]="true"
				(selectionChange)="singleTimeBasic = $event">
			</eif-custom-date-picker>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">{{ singleTimeBasic ?? '—' }}</div>
			</div>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Single + Time — Flat Date</h3>
			<p class="ds-example__header-subtitle">showTime: true · emitFlatDate: true</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				[label]="'Meeting DateTime'"
				[fullWidth]="true"
				[placeholder]="'Select date and time'"
				[name]="'single-time-flat'"
				[showTime]="true"
				[emitFlatDate]="true"
				(selectionChange)="singleTimeFlatDate = $event">
			</eif-custom-date-picker>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">{{ singleTimeFlatDate ?? '—' }}</div>
			</div>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Single + Time — Format</h3>
			<p class="ds-example__header-subtitle">showTime: true · format: 'YYYY-MM-DD'</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				[label]="'Meeting DateTime'"
				[fullWidth]="true"
				[placeholder]="'Select date and time'"
				[name]="'single-time-format'"
				[showTime]="true"
				[format]="'YYYY-MM-DD'"
				(selectionChange)="singleTimeFormat = $event">
			</eif-custom-date-picker>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">{{ singleTimeFormat ?? '—' }}</div>
			</div>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Single + Time — Emit Format</h3>
			<p class="ds-example__header-subtitle">showTime: true · emitFormat: 'YYYY-MM-DD HH:mm:ss'</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				[label]="'Meeting DateTime'"
				[fullWidth]="true"
				[placeholder]="'Select date and time'"
				[name]="'single-time-emit-format'"
				[showTime]="true"
				[emitFormat]="'YYYY-MM-DD HH:mm:ss'"
				(selectionChange)="singleTimeEmitFormat = $event">
			</eif-custom-date-picker>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">{{ singleTimeEmitFormat ?? '—' }}</div>
			</div>
		</div>
	</div>

	<!-- ═══════════════════ RANGE DATE + TIME PICKERS ═══════════════════ -->

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Range + Time — Basic</h3>
			<p class="ds-example__header-subtitle">isRange: true · showTime: true</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				[label]="'Date Range'"
				[fullWidth]="true"
				[placeholder]="'Select date range'"
				[name]="'range-time-basic'"
				[isRange]="true"
				[calendars]="2"
				[showTime]="true"
				(selectionChange)="rangeTimeBasic = $event">
			</eif-custom-date-picker>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">{{ rangeTimeBasic?.[0] ?? '—' }} — {{ rangeTimeBasic?.[1] ?? '—' }}</div>
			</div>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Range + Time — Flat Date</h3>
			<p class="ds-example__header-subtitle">isRange: true · showTime: true · emitFlatDate: true</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				[label]="'Date Range'"
				[fullWidth]="true"
				[placeholder]="'Select date range'"
				[name]="'range-time-flat'"
				[isRange]="true"
				[calendars]="2"
				[showTime]="true"
				[emitFlatDate]="true"
				(selectionChange)="rangeTimeFlatDate = $event">
			</eif-custom-date-picker>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">{{ rangeTimeFlatDate?.[0] ?? '—' }} — {{ rangeTimeFlatDate?.[1] ?? '—' }}</div>
			</div>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Range + Time — Format</h3>
			<p class="ds-example__header-subtitle">isRange: true · showTime: true · format: 'YYYY-MM-DD'</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				[label]="'Date Range'"
				[fullWidth]="true"
				[placeholder]="'Select date range'"
				[name]="'range-time-format'"
				[isRange]="true"
				[calendars]="2"
				[showTime]="true"
				[format]="'YYYY-MM-DD'"
				(selectionChange)="rangeTimeFormat = $event">
			</eif-custom-date-picker>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">{{ rangeTimeFormat?.[0] ?? '—' }} — {{ rangeTimeFormat?.[1] ?? '—' }}</div>
			</div>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Range + Time — Emit Format</h3>
			<p class="ds-example__header-subtitle">isRange: true · showTime: true · emitFormat: 'YYYY-MM-DD HH:mm:ss'</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				[label]="'Date Range'"
				[fullWidth]="true"
				[placeholder]="'Select date range'"
				[name]="'range-time-emit-format'"
				[isRange]="true"
				[calendars]="2"
				[showTime]="true"
				[emitFormat]="'YYYY-MM-DD HH:mm:ss'"
				(selectionChange)="rangeTimeEmitFormat = $event">
			</eif-custom-date-picker>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">{{ rangeTimeEmitFormat?.[0] ?? '—' }} — {{ rangeTimeEmitFormat?.[1] ?? '—' }}</div>
			</div>
		</div>
	</div>

	<!-- ═══════════════════ SPECIAL ═══════════════════ -->

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">With Icon & Tooltip</h3>
			<p class="ds-example__header-subtitle">Includes information tooltip</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				[label]="'Deadline'"
				[color]="'info'"
				[fullWidth]="true"
				[placeholder]="'Select deadline'"
				[icon]="'fa-solid fa-calendar'"
				[name]="'date-picker-tooltip'"
				[tooltip]="'Choose your project deadline'"
				(selectionChange)="tooltipDate = $event">
			</eif-custom-date-picker>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--info">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">{{ tooltipDate ?? '—' }}</div>
			</div>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Disabled State</h3>
			<p class="ds-example__header-subtitle">Cannot be modified</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				[label]="'Locked Date'"
				[fullWidth]="true"
				[placeholder]="'Cannot change'"
				[name]="'date-picker-disabled'"
				[disabled]="true">
			</eif-custom-date-picker>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--disabled">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">—</div>
			</div>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Required Date</h3>
			<p class="ds-example__header-subtitle">Validation on button click</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-date-picker
				#validationDatePicker
				[label]="'Required Date'"
				[fullWidth]="true"
				[placeholder]="'Select a date'"
				[name]="'date-picker-required'"
				[validationRules]="requiredDateRules"
				(selectionChange)="requiredDate = $event"
				(validationChange)="onValidationChange($event)">
			</eif-custom-date-picker>
			<eif-custom-button
				[text]="'Validate'"
				[type]="'button'"
				[size]="'small'"
				[preIcon]="'fa-solid fa-check'"
				(action)="validationDatePicker.validate()">
			</eif-custom-button>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Output:</div>
				<div class="ds-value__content">{{ requiredDate ?? '—' }}</div>
			</div>
			<div class="ds-value ds-mt-1">
				<div class="ds-value__label">Valid:</div>
				<div class="ds-value__content">{{ validationValid ? 'Yes' : 'No' }}</div>
			</div>
		</div>
	</div>
</div>
